import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTimer } from 'react-timer-hook';
import styles from './Timer.css';

const cx = classnames.bind(styles);

function Timer({expiryTimestamp, className, onExpire}) {
    const [isStart, setIsStart] = useState(true);
    const {minutes, hours, isRunning, seconds, days} = useTimer({expiryTimestamp, onExpire});

    // useEffect(() => {
    //     setTimeout(() => {
    //         setIsStart(true);
    //     }, 4500);
    // }, []);

    if (!isRunning) {
        return null;
    }

    const classes = cx({
        root: true,
        [className]: Boolean(className),
        start: isStart
    });

    return (
        <div className={classes}>
            {<span>{isStart ? `${days < 10 ? '0' : ''}${days}` : ''}d</span>}
            :
            <span>{isStart ? `${hours < 10 ? '0' : ''}${hours}` : ''}h</span>
            :
            <span>{isStart ? `${minutes < 10 ? '0' : ''}${minutes}` : ''}m</span>
            :
            <span>{isStart ? `${seconds < 10 ? '0' : ''}${seconds}` : ''}s</span>
        </div>
    )
}

Timer.propTypes = {
    expiryTimestamp: PropTypes.number,
    className: PropTypes.string,
    onExpire: PropTypes.func
}

Timer.defaultProps = {
    className: '',
    onExpire: () => {}
}

export {
    Timer
}
